import { render, staticRenderFns } from "./SideBarFilter.vue?vue&type=template&id=4d00871f"
import script from "./SideBarFilter.vue?vue&type=script&lang=js"
export * from "./SideBarFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports